import Http from '../http'

// 基础组件模块API
export default {
  // 获取终端列表
  getVehiclesListByCar(params) {
    return Http.post('/index/likeDev.do', params)
  },
  // Tree
  // 获取终端列表
  getVehiclesList(params) {
    return Http.post('/index/vehiGroup.do', params)
  },
  // 关联存储服务器终端列表
  getStoreVehiclesList(params) {
    return Http.post('/alarmAction/devStoreList.do', params)
  },
  // 关联下载服务器终端列表
  getDownloadVehiclesList(params) {
    return Http.post('/wifi/devStoreList.do', params)
  },
  // 已分组列表
  getGroupList(params) {
    return Http.post('/group/dealList.do', params)
  },
  // 未分组列表
  getUnGroupList(params) {
    return Http.post('/group/undealList.do', params)
  },
  // 地图
  // 添加点-线-面
  addGraph(params) {
    return Http.post('/marker/add.do', params)
  },
  // 删除点线面
  deleteGraph(params) {
    // 1点 2矩形  3多边形  4线  10圆
    return Http.post('/marker/delete.do', params)
  },
  // 获取tab导航条权限
  getPrivis() {
    return Http.post('/index/getTopMenu.do')
  },
  // 获取用户管理中未授权车辆
  getUnAuthDevice(params) {
    return Http.post('clients/getUnauthorized.do', params)
  },
  getAuthDevice(params) {
    return Http.post('clients/getPermits.do', params)
  },
  // 设置默认位置
  setLocation(params) {
    return Http.post('user/setLocation.do', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/baseComponents.js